var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.org_types_by_name)?_c('DBEditor',{attrs:{"object_function":"create","object_fq_name":"org.unit","modal_id":_vm.modal_id,"presets":_vm.presets,"input_reducer":_vm.reducer,"non_optionals_order":['fq_name', 'type']}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }